import '@ant-design/v5-patch-for-react-19';
import { useState, useEffect } from "react";
import { Button, Card, Col, DatePicker, Form, Input, Modal, Row, Select, Spin, Tooltip } from "antd";
import { useNavigate } from "react-router-dom";

import dayjs from "dayjs";

import api, { apiConvenio, apiEntidade, apiEstados, apiPrimarias, type IErroApi } from "../../../services/api";

import "../../../styles/sider.css";

import { errorMessage, mostrarInfo, mostrarInfoDetail } from "../../../messages/messages";
// import { errorMessage, successMessage } from "../../../messages/messages";

import { CheckOutlined, SearchOutlined } from "@ant-design/icons";
import { carregaCEP, carregaListaMunicipios, carregaListaNaturezasJuridicasIbge, carregaListaPaises, carregaListaUF, consultaCNPJReceita, existeNumeroCadastrado } from "../services";
import { maskCep, maskCnpj, maskNumeroProcesso, maskTelefone } from "../../../utils/maskFunctions";
import type { IAlteracaoEfpc, IAutorizacaoEfpc, IAutorizacaoPlano, IEfpc, IPessoaJuridica, IPlanoBeneficios, ISelectList } from "../../../components/Interfaces";
import CadInfoBotoes from '../../../components/CadInfoBotoes';
import { pushToBase } from '../../../utils/utilsFunctions';

const TesteApi = () => {
  const navigate = useNavigate();

  const { TextArea } = Input;
  const history = useNavigate();
  // const { confirm } = Modal;
  // Lista que armazena as Naturezas Juridicas retornadas da API
  // Flag para disparar o Carregamento da Pagina
  const [loading, setLoading] = useState(false);
  const [tipLoading, setTipLoading] = useState("");
  const [form] = Form.useForm();
  const [tipoIdentificador, setTipoIdentificador] = useState<number>(0); // 0: Não definico / 1: CNPJ / 2: NIF
  const [cnpjAProcessar, setCnpjAProcessar] = useState("");
  const [listaNaturezasJuridicas, setListaNaturezasJuridicas] = useState<ISelectList[]>([]);
  const [listaPaises, setListaPaises] = useState<ISelectList[]>([]);
  const [listaUf, setListaUf] = useState<ISelectList[]>([]);
  const [listaMunicipios, setListaMunicipios] = useState([]);
  const [codPais, setCodPais] = useState(76); // BRASIL
  const [codNaturezaJuridica, setCodNaturezaJuridica] = useState(0);
  const [modalJaExisteAberto, setModalJaExisteAberto] = useState(false);
  const [modalSucessoAberto, setModalSucessoAberto] = useState(false);

  const [dadosPessoaJuridica, setDadosPessoaJuridica] = useState<IPessoaJuridica>();
  const [razaoSocial, setRazaoSocial] = useState<IPessoaJuridica>();
  const [cnaePrincipal, setCnaePrincipal] = useState("");

  const [estadoErroApi, setEstadoErroApi] = useState(0)
  const [msgErroApi, setMsgErroApi] = useState("")
  const [erroApi, setErroApi] = useState<IErroApi>()


  useEffect(() => {
    if (dadosPessoaJuridica) pushToManter(dadosPessoaJuridica, 2);
  }, [dadosPessoaJuridica]); // eslint-disable-line react-hooks/exhaustive-deps

  function pushToManter(pj: any, manter: number) {
    let tpSelecao = {
      manter: manter,
      data: pj
    };

    navigate("base/pessoa-juridica-manter", { state: tpSelecao });
  }

  useEffect(() => {

  }, []);

  useEffect(() => {
    if (erroApi) {
      if (estadoErroApi === 400) {
        mostrarInfoDetail("Erro de Requisição", erroApi);
      } else if (estadoErroApi === 401) {
        mostrarInfo("Erro de Acesso", "Não autorizado. Tente fazer o login novamente. Mensagem do servidor: " + msgErroApi);
      } else if (estadoErroApi === 403) {
        mostrarInfo("Erro de Acesso", "O acesso ao recurso é proibido. Mensagem do servidor: " + msgErroApi);
      } else {
        mostrarInfo("Erro de comunicação", "Verifique na opção consulta se o cadastro foi efetivado. Mensagem do servidor: " + msgErroApi);
      }
      setErroApi(undefined);
      setEstadoErroApi(0);
      setMsgErroApi("");

    }
  }, [erroApi])

  // const nacional = (tipoIdentificador: number) => {
  //   return tipoIdentificador === 1 || tipoIdentificador === 2;
  // }


  const efpcInseirPrimeiro = async () => {
    // setLoading(true);

    const json: IEfpc = {
      numero: "1",
      serie: undefined,
      sigla: "TESTE",
      quantidadeDiretores: 1,
      quantidadeConselheiroFiscal: 1,
      quantidadeConselhoDeliberativo: 1,
      fundamentacaoLegal: 1,
      tipo: 1,
      observacoes: "OBS",
      usuarioAtualizacao: undefined,
      justificativaAtualizacao: "JUSTIFICATIVA",
      dataVigencia: "2025-01-01T00:00:00",
      documentos: [],
      numeroPessoaJuridica: "00360305000104"
    };

    //console.log(json);


  };


  const efpcAutorizacaoRequerer = async () => {
    // setLoading(true);


    const jsonRequisicao: IAutorizacaoEfpc =
    {
      "numeroPessoaJuridicaRequerente": "00360305000104",
      "dataPosicao": "1979-06-11T00:00:00",
      "justificativa": "TESTE NÚMERO 01 DE CRIAÇÃO DE EFPC FUNCEF2",
    }

    //console.log("json subindo");
    //console.log(jsonRequisicao);

    try {
      let query = `/efpc/autorizacao/requerer`;

      const { data } = await apiPrimarias.post(query, jsonRequisicao);
      setLoading(false);

      //console.log(data);

      setModalSucessoAberto(true);
    } catch (error: any) {
      setLoading(false);
      if (error.response) {
        errorMessage(`${error.response.data.mensagem}`);
        if (error.response.data.campos) {
          error.response.data.campos.map((c: any) => {
            errorMessage(`${c.cmensagem}`);
          });
        }
      }
      // Return comentado pq esta retornando essa mensagem de erro por default para todos os erros de cadastro
      // return errorMessage("Ocorreu um erro ao tentar realizar uma operação");
    }
  };

  const efpcAlteracaoRequerer = async () => {
    // setLoading(true);


    const jsonRequisicao: IAlteracaoEfpc =
    {
      "serieEfpc": 1,
      "dataPosicao": "2025-10-11T00:00:00",
      // "justificativaAtualizacao": "REQUISIÇÃO DE ALTERAÇÃO DA FUNPRESP",
      // "docAtualizacao": 0
    }

    //console.log("json subindo");
    //console.log(jsonRequisicao);

    try {
      let query = `/efpc/alteracao/requerer`;

      const { data } = await apiPrimarias.post(query, jsonRequisicao);
      setLoading(false);

      //console.log(data);

      setModalSucessoAberto(true);
    } catch (error: any) {
      setLoading(false);
      if (error.response) {
        errorMessage(`${error.response.data.mensagem}`);
        if (error.response.data.campos) {
          error.response.data.campos.map((c: any) => {
            errorMessage(`${c.cmensagem}`);
          });
        }
      }
      // Return comentado pq esta retornando essa mensagem de erro por default para todos os erros de cadastro
      // return errorMessage("Ocorreu um erro ao tentar realizar uma operação");
    }
  };


  const efpcAutorizacaoAprovar = async () => {
    // setLoading(true);

    const json: IEfpc =
    {
      "quantidadeConselhoDeliberativo": 7,
      "tipo": 1,
      "dataVigencia": "2025-12-09",
      "documentos": [
        {
          "idCtrlDocTpDoc": 2,
          "idDocumento": 1,
          "marcadoParaExclusao": false,
          "idDocCad": -1,
          "dtDocumento": "2025-12-19",
          "documentoChave": {
            "ativo": true,
            "idDocumento": 1
          },
          "nuDocumento": "",
          "nmDocumento": ""
        },
        {
          "idCtrlDocTpDoc": 3,
          "idDocumento": 1,
          "marcadoParaExclusao": false,
          "idDocCad": -1,
          "dtDocumento": "2025-12-19",
          "documentoChave": {
            "ativo": true,
            "idDocumento": 1
          },
          "nuDocumento": "",
          "nmDocumento": ""
        },
        {
          "idCtrlDocTpDoc": 4,
          "idDocumento": 1,
          "marcadoParaExclusao": false,
          "idDocCad": -1,
          "dtDocumento": "2025-12-19",
          "documentoChave": {
            "ativo": true,
            "idDocumento": 1
          },
          "nuDocumento": "",
          "nmDocumento": ""
        },
        {
          "idCtrlDocTpDoc": 5,
          "idDocumento": 1,
          "marcadoParaExclusao": false,
          "idDocCad": -1,
          "dtDocumento": "2025-12-19",
          "documentoChave": {
            "ativo": true,
            "idDocumento": 1
          },
          "nuDocumento": "",
          "nmDocumento": ""
        },
        {
          "idCtrlDocTpDoc": 12,
          "idDocumento": 1,
          "marcadoParaExclusao": false,
          "idDocCad": -1,
          "dtDocumento": "2025-12-19",
          "documentoChave": {
            "ativo": true,
            "idDocumento": 1
          },
          "nuDocumento": "",
          "nmDocumento": ""
        },
        {
          "idCtrlDocTpDoc": 13,
          "idDocumento": 1,
          "marcadoParaExclusao": false,
          "idDocCad": -1,
          "dtDocumento": "2025-12-19",
          "documentoChave": {
            "ativo": true,
            "idDocumento": 1
          },
          "nuDocumento": "",
          "nmDocumento": ""
        },
        {
          "idCtrlDocTpDoc": 1,
          "idDocumento": 1,
          "marcadoParaExclusao": false,
          "idDocCad": -1,
          "dtDocumento": "2025-12-19",
          "documentoChave": {
            "ativo": true,
            "idDocumento": 1
          },
          "nuDocumento": "",
          "nmDocumento": ""
        },
        {
          "idCtrlDocTpDoc": 7,
          "idDocumento": 1,
          "marcadoParaExclusao": false,
          "idDocCad": -1,
          "dtDocumento": "2025-12-19",
          "documentoChave": {
            "ativo": true,
            "idDocumento": 1
          },
          "nuDocumento": "",
          "nmDocumento": ""
        },
        {
          "idCtrlDocTpDoc": 11,
          "idDocumento": 1,
          "marcadoParaExclusao": false,
          "idDocCad": -1,
          "dtDocumento": "2025-12-19",
          "documentoChave": {
            "ativo": true,
            "idDocumento": 1
          },
          "nuDocumento": "",
          "nmDocumento": ""
        }
      ],
      "sigla": "PREVICORP",
      "numero": "",
      "quantidadeDiretores": 3,
      "numeroPessoaJuridica": "",
      "fundamentacaoLegal": 1,
      "quantidadeConselheiroFiscal": 5
    }

    //console.log("json subindo");
    //console.log(json);

    try {
      let query = `/efpc/autorizacao/aprovar/${"1"}`;

      const { data } = await apiPrimarias.post(query, json);
      setLoading(false);

      //console.log(data);

      setModalSucessoAberto(true);
    } catch (error: any) {
      setLoading(false);
      if (error.response) {
        errorMessage(`${error.response.data.mensagem}`);
        if (error.response.data.campos) {
          error.response.data.campos.map((c: any) => {
            errorMessage(`${c.cmensagem}`);
          });
        }
      }
      // Return comentado pq esta retornando essa mensagem de erro por default para todos os erros de cadastro
      // return errorMessage("Ocorreu um erro ao tentar realizar uma operação");
    }
  };

  const efpcAlteracaoAprovar = async () => {
    // setLoading(true);

    const json: IEfpc =
    {
      "numero": "00014",
      "serie": 1,
      "sigla": "FUNCEF",
      "quantidadeDiretores": 4,
      "quantidadeConselheiroFiscal": 4,
      "quantidadeConselhoDeliberativo": 6,
      "fundamentacaoLegal": 1,
      "tipo": 1,
      "observacoes": "TESTE DE CADASTRO DA EFPC 01 - ALTERADO 01 - MUDOU quantidadeDiretores -2 ",
      "usuarioAtualizacao": "6549e8b8-804e-4cab-8af0-9d6e2d8b604b",
      "justificativaAtualizacao": "ATUALIZAÇÃO DA FUNPRESP - 01",
      dataVigencia: "2025-01-01T00:00:00",
      documentos: [],
      "numeroPessoaJuridica": "00436923000190",
    }

    //console.log("json subindo");
    //console.log(json);

    try {
      let query = `/efpc/alteracao/aprovar/${"1"}`;

      const { data } = await apiPrimarias.post(query, json);
      setLoading(false);

      //console.log(data);

      setModalSucessoAberto(true);
    } catch (error: any) {
      setLoading(false);
      if (error.response) {
        errorMessage(`${error.response.data.mensagem}`);
        if (error.response.data.campos) {
          error.response.data.campos.map((c: any) => {
            errorMessage(`${c.cmensagem}`);
          });
        }
      }
      // Return comentado pq esta retornando essa mensagem de erro por default para todos os erros de cadastro
      // return errorMessage("Ocorreu um erro ao tentar realizar uma operação");
    }
  };

  const efpcVersionar = async () => {
    // setLoading(true);

    const json: IEfpc =
    {
      "numero": "00014",
      "sigla": "FUNCEF",
      "quantidadeDiretores": 6,
      "quantidadeConselheiroFiscal": 4,
      "quantidadeConselhoDeliberativo": 6,
      "fundamentacaoLegal": 1,
      "tipo": 1,
      "observacoes": "TESTE DE CADASTRO DA EFPC 01",
      "justificativaAtualizacao": "JUSTIFICATIVA PARA O TESTE DE CADASTRO DA EFPC 01",
      dataVigencia: "2025-01-01T00:00:00",
      documentos: [],
      "numeroPessoaJuridica": ""
    }

    //console.log("json subindo");
    //console.log(json);

    try {
      let query = `/versionar/${"00014"}/numero`;

      const { data } = await apiEntidade.post(query, json);
      setLoading(false);

      //console.log(data);

      setModalSucessoAberto(true);
    } catch (error: any) {
      setLoading(false);
      if (error.response) {
        errorMessage(`${error.response.data.mensagem}`);
        if (error.response.data.campos) {
          error.response.data.campos.map((c: any) => {
            errorMessage(`${c.cmensagem}`);
          });
        }
      }
      // Return comentado pq esta retornando essa mensagem de erro por default para todos os erros de cadastro
      // return errorMessage("Ocorreu um erro ao tentar realizar uma operação");
    }
  };

  const efpcVersionarSerie = async () => {
    // setLoading(true);

    const json: IEfpc =
    {
      "numero": "00045",
      "serie": 4,
      "sigla": "ALCOA PREVI",
      "quantidadeDiretores": 10,
      "quantidadeConselheiroFiscal": 10,
      "quantidadeConselhoDeliberativo": 18,
      "fundamentacaoLegal": 1,
      "tipo": 1,
      "dataVigencia": "",
      "numeroPessoaJuridica": "44011011285202436",
      "documentos": []
    }

    //console.log("json subindo");
    //console.log(json);

    try {
      let query = `/versionar/${4}/serie`;

      const { data } = await apiEntidade.post(query, json);
      setLoading(false);

      //console.log(data);

      setModalSucessoAberto(true);
    } catch (error: any) {
      setLoading(false);
      if (error.response) {
        errorMessage(`${error.response.data.mensagem}`);
        if (error.response.data.campos) {
          error.response.data.campos.map((c: any) => {
            errorMessage(`${c.cmensagem}`);
          });
        }
      }
      // Return comentado pq esta retornando essa mensagem de erro por default para todos os erros de cadastro
      // return errorMessage("Ocorreu um erro ao tentar realizar uma operação");
    }
  };

  const sendForm = async () => {
    // setLoading(true);

    const json: IEfpc = {
      numero: "1",
      serie: undefined,
      sigla: "TESTE",
      quantidadeDiretores: 1,
      quantidadeConselheiroFiscal: 1,
      quantidadeConselhoDeliberativo: 1,
      fundamentacaoLegal: 1,
      tipo: 1,
      observacoes: "OBS",
      usuarioAtualizacao: undefined,
      justificativaAtualizacao: "JUSTIFICATIVA",
      dataVigencia: "2025-01-01T00:00:00",
      documentos: [],
      numeroPessoaJuridica: "00360305000104"
    };

    //console.log(json);


    // try {
    //   let query = `/inserir-primeiro`;

    //   const { data } = await apiEntidade.post(query, json);
    //   setLoading(false);
    //   setDadosPessoaJuridica(data);

    //   setModalSucessoAberto(true);
    // } catch (error: any) {
    //   setLoading(false);
    //   if (error.response) {
    //     errorMessage(`${error.response.data.mensagem}`);
    //     if (error.response.data.campos) {
    //       error.response.data.campos.map((c: any) => {
    //         errorMessage(`${c.cmensagem}`);
    //       });
    //     }
    //   }
    //   // Return comentado pq esta retornando essa mensagem de erro por default para todos os erros de cadastro
    //   // return errorMessage("Ocorreu um erro ao tentar realizar uma operação");
    // }
  };





  const carregaListaUFOpcoes = async () => {
    let listaLocal: any = [];
    await carregaListaUF().then((response) => {
      response.data.forEach((p: any) => {
        listaLocal.push({ value: p.id, label: p.sigla })
      });
    });
    setListaUf(listaLocal);
  }

  const getOperacaoPorSeriePessoaJuridica = async () => {
    try {
      setLoading(true);

      let serie = 6;

      let lQuery = `/efpc/autorizacao/${serie}/serie`;
      const { data } = await apiPrimarias.get(lQuery);
      //console.log(data);

    } catch (error) {
      //console.log(error);
      errorMessage("Não foi possível realizar a consulta");
    } finally {
      setLoading(false);
    }
  };


  // if (loading) {
  //   return <Spin />;
  // }



  const testeRedirectUri = async () => {
    // setLoading(true);

    let numero = "7";
    try {
      let query = `/teste-uri/${numero}`;

      const { data } = await apiEntidade.get(query);
      setLoading(false);

      //console.log(data);

    } catch (error: any) {
      setLoading(false);
      if (error.response) {
        errorMessage(`${error.response.data.mensagem}`);
        if (error.response.data.campos) {
          error.response.data.campos.map((c: any) => {
            errorMessage(`${c.cmensagem}`);
          });
        }
      }
      // Return comentado pq esta retornando essa mensagem de erro por default para todos os erros de cadastro
      // return errorMessage("Ocorreu um erro ao tentar realizar uma operação");
    }
  };

  const testeGetEfpcByNumero = async () => {
    // setLoading(true);

    let numero = "00014";
    try {
      let query = `/ultimo/${numero}/numero`;

      const { data } = await apiEntidade.get(query);
      setLoading(false);

      //console.log(data);

    } catch (error: any) {
      setLoading(false);
      if (error.response) {
        errorMessage(`${error.response.data.mensagem}`);
        if (error.response.data.campos) {
          error.response.data.campos.map((c: any) => {
            errorMessage(`${c.cmensagem}`);
          });
        }
      }
      // Return comentado pq esta retornando essa mensagem de erro por default para todos os erros de cadastro
      // return errorMessage("Ocorreu um erro ao tentar realizar uma operação");
    }
  };

  const testeGetEstados = async () => {
    // setLoading(true);

    try {
      let query = `/estado`;

      const { data } = await apiEstados.get(query);
      setLoading(false);

      //console.log(data);

    } catch (error: any) {
      setLoading(false);
      if (error.response) {
        errorMessage(`${error.response.data.mensagem}`);
        if (error.response.data.campos) {
          error.response.data.campos.map((c: any) => {
            errorMessage(`${c.cmensagem}`);
          });
        }
      }
      // Return comentado pq esta retornando essa mensagem de erro por default para todos os erros de cadastro
      // return errorMessage("Ocorreu um erro ao tentar realizar uma operação");
    }
  };


  const pessoaJuridicaVersionarNumeroProcesso = async () => {
    // setLoading(true);
    //       "razaoSocial": "POSTALIS INSTITUTO DE PREVIDENCIA COMPLEMENTAR",

    const json: IPessoaJuridica =
    {
      "numero": "44011011375202516",
      "nomeFantasia": "POSTALIS",
      "razaoSocial": "",
      "observacao": "TESTE CADASTRO PJ POSTALIS",
      "naturezaJuridica": 1015,
      "numeroProcesso": "44011011375202516",
      "cep": "70715900",
      "tipoLogradouro": "",
      "logradouro": "QUADRA SCN QUADRA 5 BLOCO A",
      "numeroEndereco": "1",
      "complemento": "BRASÍLIA SHOPPING AND TOWERS",
      "bairro": "ASA NORTE",
      "siglaUf": "DF",
      "telefone1": "6130033669",
      "nomePais": "BRASIL",
      "pais": 76,
      "site": "WWW.POSTALIS.COM.BR",
      "email": "PRESIDENCIA@POSTALIS.COM.BR",
      "emailInstitucional": "",
      "nomeCidade": "BRASÍLIA",
      "tipoIdentificador": 3
    }

    //console.log("json subindo");
    //console.log(json);

    try {
      let query = `/versionar/${json.tipoIdentificador}/${json.numero}/numero`;

      const { data } = await api.post(query, json);
      setLoading(false);

      //console.log(data);

      setModalSucessoAberto(true);
    } catch (error: any) {
      setLoading(false);
      if (error.response) {
        errorMessage(`${error.response.data.mensagem}`);
        if (error.response.data.campos) {
          error.response.data.campos.map((c: any) => {
            errorMessage(`${c.cmensagem}`);
          });
        }
      }
      // Return comentado pq esta retornando essa mensagem de erro por default para todos os erros de cadastro
      // return errorMessage("Ocorreu um erro ao tentar realizar uma operação");
    }
  };

  const pessoaJuridicaVersionarNIT = async () => {
    // setLoading(true);
    //       "razaoSocial": "POSTALIS INSTITUTO DE PREVIDENCIA COMPLEMENTAR",

    const json: IPessoaJuridica =
    {
      "numero": "333333333333333333333",
      "nomeFantasia": "dddd",
      "razaoSocial": "sss",
      "naturezaJuridica": 1015,
      "numeroProcesso": "44011006129202534",
      "cep": "44444",
      "logradouro": "DDD",
      "numeroEndereco": "DDD",
      "bairro": "TTTT",
      "siglaUf": "XX",
      "telefone1": "66666666666",
      "nomePais": "ANTÍGUA E BARBUDA",
      "pais": 28,
      "email": "t@te.com",
      "nomeCidade": "TTTT",
      "tipoIdentificador": 2,
      complemento: ""

    }

    //console.log("json subindo");
    //console.log(json);

    try {
      let query = `/versionar/${json.tipoIdentificador}/${json.numero}/numero`;

      const { data } = await api.post(query, json);
      setLoading(false);

      //console.log(data);

      setModalSucessoAberto(true);
    } catch (error: any) {
      setLoading(false);
      if (error.response) {
        errorMessage(`${error.response.data.mensagem}`);
        if (error.response.data.campos) {
          error.response.data.campos.map((c: any) => {
            errorMessage(`${c.cmensagem}`);
          });
        }
      }
      // Return comentado pq esta retornando essa mensagem de erro por default para todos os erros de cadastro
      // return errorMessage("Ocorreu um erro ao tentar realizar uma operação");
    }
  };

  const efpcAutorizacaoRequererCadastroAutomaticoPjEfpc = async () => {
    // setLoading(true);

    const jsonPjEfpc: IPessoaJuridica =
    {
      "numero": "440000043441993",
      "nomeFantasia": "GEBSA-PREV",
      "razaoSocial": "GEBSA-PREV-SOCIEDADE DE PREVIDENCIA PRIVADA",
      "observacao": "NOVO ENDEREÇO DA ENTIDADE:\nAVENIDA MAGALHÃES DE CASTRO, 4800 ¿ 12º ANDAR  TORRE CONTINENTAL\nSÃO PAULO/SP - CEP: 05676-120",
      "naturezaJuridica": 3069,
      "numeroProcesso": "440000043441993",
      "cep": "05676120",
      "logradouro": "AVENIDA MAGALHÃES DE CASTRO",
      "numeroEndereco": "4800",
      "complemento": "DE 1287 ATÉ 99998 - DE 1287/1288 AO FIM",
      "bairro": "CIDADE JARDIM",
      "siglaUf": "SP",
      "telefone1": "1150269045",
      "nomePais": "BRASIL",
      "pais": 76,
      "site": "www.gebsaprev.org.br",
      "email": "ATENDIMENTO@GEBSAPREV.COM",
      "nomeCidade": "SÃO PAULO",
      "tipoIdentificador": 3
    }



    const jsonRequisicao: IAutorizacaoEfpc =
    {
      "numeroPessoaJuridicaRequerente": "58088733000100",
      "dataPosicao": "2008-06-18T00:00:00",
      "justificativa": "TESTE DE CRIAÇÃO DE EFPC GEBSA-PREV",
      pessoaJuridicaObjeto: jsonPjEfpc
    }

    //console.log("json subindo");
    //console.log(jsonRequisicao);

    try {
      let query = `/efpc/autorizacao/requerer`;

      const { data } = await apiPrimarias.post(query, jsonRequisicao);
      setLoading(false);

      //console.log(data);

      setModalSucessoAberto(true);
    } catch (error: any) {
      setLoading(false);
      if (error.response) {
        errorMessage(`${error.response.data.mensagem}`);
        if (error.response.data.campos) {
          error.response.data.campos.map((c: any) => {
            errorMessage(`${c.cmensagem}`);
          });
        }
      }
      // Return comentado pq esta retornando essa mensagem de erro por default para todos os erros de cadastro
      // return errorMessage("Ocorreu um erro ao tentar realizar uma operação");
    }
  };

  const getPessoaJuridicaUltimo = async () => {
    // setLoading(true);

    try {
      let query = `/ultimo/4/serie`;

      const { data } = await api.get(query);
      setLoading(false);

      //console.log(data);

    } catch (error: any) {
      setLoading(false);
      if (error.response) {
        errorMessage(`${error.response.data.mensagem}`);
        if (error.response.data.campos) {
          error.response.data.campos.map((c: any) => {
            errorMessage(`${c.cmensagem}`);
          });
        }
      }
      // Return comentado pq esta retornando essa mensagem de erro por default para todos os erros de cadastro
      // return errorMessage("Ocorreu um erro ao tentar realizar uma operação");
    }
  };


  const planoAutorizacaoAprovarCadastroAutomaticoPjPlano = async () => {
    // setLoading(true);


    let jsonPlano: IPlanoBeneficios =
    {
      "numero": "",
      "serie": -1,
      "nome": "PLANO PREDEFINIDO DA ECOPREV",
      "sigla": "ECO-PREVIDA",
      "caracteristica": 1,
      "modalidade": 1,
      "fundamentacaoLegal": 1,
      "tipoRegulamento": 1,
      "codigoModelo": "PADRON",
      "contribuicaoMinima": 5.55,
      "unidadeMedidaContribuicaoMinima": 1,
      "permiteAdesaoDependente": true,
      "indicadorPrevidencial": true,
      "preveInscricaoAutomatica": true,
      "limiteMaximoSalario": true,
      "preveContribuicaoMinima": true,
      "contribuicaoNormalAssistido": true,
      "contribuicaoNormalParticipante": true,
      "contribuicaoNormalPatrocinador": true,
      "contribuicaoDespesaAdministrativaAssistido": true,
      "contribuicaoDespesaAdministrativaParticipante": true,
      "contribuicaoDespesaAdministrativaPatrocinador": true,
      "contribuicaoServicoPassadoAssistido": true,
      "contribuicaoServicoPassadoParticipante": true,
      "contribuicaoServicoPassadoPatrocinador": true,
      "ofereceResgateParcial": false,
      "numeroEfpc": "00014",
      "numeroPessoaJuridica": "0332981296",
      "dataVigencia": "1983-03-21",
      "beneficios": [
        {
          "id": "",
          "nome": "BENEF 01",
          "regimeFinanceiro": 5,
          "metodoFinanciamento": 1,
          "tipoExpressaoBeneficio": 1,
          "prazoPagamento": 1,
          "reservaAtuarialAcumulacao": true,
          "reservaAtuarialConcessao": true,
          "beneficioFacultativo": true,
          "beneficioMinimo": true,
          "riscoSeguradora": true,
          "fundamentacaoRegulamentar": "FUND INVALIDEZ",
          "beneficioExpresso": 1,
          "tipoBeneficioId": "03cefd13-c20f-40cb-b7b0-16308d5a19a6",
          "regrasCalculo": [
            {
              "id": "",
              "tipoRegraCalculoId": "e3753913-ff44-48f1-8d40-c5b86da683d8",
              "marcadoParaExclusao": false,
              "tipoComplementoId": ""
            },
            {
              "id": "",
              "tipoRegraCalculoId": "7f42b68b-9bf8-40f4-abb0-e30479509c0a",
              "marcadoParaExclusao": false,
              "tipoComplementoId": ""
            }
          ],
          "requisitosElegibilidade": [
            {
              "id": "",
              "tipoRequisitoElegibilidadeId": "9bd06fe5-f773-4bec-a251-94e1a75c9295",
              "marcadoParaExclusao": false,
              "tipoComplementoId": ""
            },
            {
              "id": "",
              "tipoRequisitoElegibilidadeId": "d76d58ce-3400-44c0-9bc3-1fb7ef135424",
              "marcadoParaExclusao": false,
              "tipoComplementoId": ""
            }
          ],
          "emEdicao": false,
          "marcadoParaExclusao": false
        },
        {
          "id": "",
          "nome": "BENEF 02",
          "regimeFinanceiro": 7,
          "metodoFinanciamento": 0,
          "tipoExpressaoBeneficio": 1,
          "prazoPagamento": 3,
          "reservaAtuarialAcumulacao": true,
          "reservaAtuarialConcessao": true,
          "beneficioFacultativo": true,
          "beneficioMinimo": true,
          "riscoSeguradora": true,
          "fundamentacaoRegulamentar": "FUND PENSÃO MORTE",
          "beneficioExpresso": 1,
          "tipoBeneficioId": "026857fa-cd32-4a61-8946-788cd0248772",
          "regrasCalculo": [
            {
              "id": "",
              "tipoRegraCalculoId": "e3753913-ff44-48f1-8d40-c5b86da683d8",
              "marcadoParaExclusao": false,
              "tipoComplementoId": ""
            },
            {
              "id": "",
              "tipoRegraCalculoId": "db3488fb-1f23-463e-9c8f-234703ff79bb",
              "marcadoParaExclusao": false,
              "tipoComplementoId": ""
            }
          ],
          "requisitosElegibilidade": [
            {
              "id": "",
              "tipoRequisitoElegibilidadeId": "d76d58ce-3400-44c0-9bc3-1fb7ef135424",
              "marcadoParaExclusao": false,
              "tipoComplementoId": ""
            },
            {
              "id": "",
              "tipoRequisitoElegibilidadeId": "aab5b316-36e1-475a-8d4f-e9d7ff09c1db",
              "marcadoParaExclusao": false,
              "tipoComplementoId": ""
            }
          ],
          "emEdicao": false,
          "marcadoParaExclusao": false
        }
      ],
      "institutos": [
        {
          "id": "",
          "fundamentacaoRegulamentar": "FUND AUTO",
          "detalhamento": "DET AUTO",
          "resgateParcial": false,
          "validado": 0,
          "tipoInstitutoId": "f425f5cc-1094-40d8-9ca7-fe26f7fe3544",
          "inicioId": "",
          "fimId": "",
          "componentes": [],
          "emEdicao": false,
          "tableKey": "f425f5cc-1094-40d8-9ca7-fe26f7fe3544",
          "tipoInstitutoNome": "AUTOPATROCÍNIO"
        },
        {
          "id": "",
          "fundamentacaoRegulamentar": "FUND BPD",
          "detalhamento": "DET BPD",
          "resgateParcial": false,
          "validado": 0,
          "carencia": 1,
          "unidadeMedidaCarencia": 0,
          "tipoInstitutoId": "3c61a289-e74d-424a-bcb1-543100a43970",
          "inicioId": "",
          "fimId": "",
          "componentes": [],
          "emEdicao": false,
          "tableKey": "3c61a289-e74d-424a-bcb1-543100a43970",
          "tipoInstitutoNome": "BENEFÍCIO PROPORCIONAL DIFERIDO"
        },
        {
          "id": "",
          "fundamentacaoRegulamentar": "FUND PORTABILIDADE",
          "detalhamento": "DET PORTA",
          "resgateParcial": false,
          "validado": 0,
          "carencia": 1,
          "unidadeMedidaCarencia": 0,
          "tipoInstitutoId": "0c8ea24f-8f19-4b1a-81dd-a237406db167",
          "inicioId": "",
          "fimId": "",
          "componentes": [
            {
              "id": "",
              "tipoComponenteResgatePortabilidadeId": "bc86a8d2-e9b4-4223-b2e0-0679e1f49313",
              "inicioId": "",
              "fimId": "",
              "marcadoParaExclusao": false
            },
            {
              "id": "",
              "tipoComponenteResgatePortabilidadeId": "8f6464fa-f4f9-4e4b-a09b-4a0331f22ffd",
              "inicioId": "",
              "fimId": "",
              "marcadoParaExclusao": false
            }
          ],
          "emEdicao": false,
          "tableKey": "0c8ea24f-8f19-4b1a-81dd-a237406db167",
          "tipoInstitutoNome": "PORTABILIDADE"
        },
        {
          "id": "",
          "fundamentacaoRegulamentar": "FUND RESGATE",
          "detalhamento": "",
          "resgateParcial": false,
          "validado": 0,
          "carencia": 0,
          "unidadeMedidaCarencia": 0,
          "tipoInstitutoId": "43d1eddd-bf97-40f9-aace-89026f0d4a2d",
          "inicioId": "",
          "fimId": "",
          "componentes": [
            {
              "id": "",
              "tipoComponenteResgatePortabilidadeId": "bc86a8d2-e9b4-4223-b2e0-0679e1f49313",
              "inicioId": "",
              "fimId": "",
              "marcadoParaExclusao": false
            },
            {
              "id": "",
              "tipoComponenteResgatePortabilidadeId": "521c063c-b46a-47e2-b863-9df2747c652f",
              "inicioId": "",
              "fimId": "",
              "marcadoParaExclusao": false
            }
          ],
          "emEdicao": false,
          "tableKey": "43d1eddd-bf97-40f9-aace-89026f0d4a2d",
          "tipoInstitutoNome": "RESGATE"
        }
      ],
      "documentos": []
    }

    try {
      let query = `/plano-de-beneficios/autorizacao/aprovar/1`;

      const { data } = await apiPrimarias.post(query, jsonPlano);
      setLoading(false);

      //console.log(data);

      setModalSucessoAberto(true);
    } catch (error: any) {
      let data: IErroApi = error.response.data;
      let msgErro = data.mensagem ? data.mensagem : error.response.data.message;
      let msgDetalheErro = data.campos ? ". " + data.campos[0].cmensagem : "";
      setEstadoErroApi(error.response.status);
      setMsgErroApi(msgErro + msgDetalheErro);
      if (error.response.status < 500) {
        setErroApi(data);
      } else {
        if (error.response.status === 503)
          errorMessage("Servidor remoto não disponível");
        else
          errorMessage(msgErro);
      }
    } finally {
      setLoading(false);
    }
  };

  const getConveniosPorSeriePlano = async () => {
    try {
      setLoading(true);

      let serie = 7425;

      let lQuery = `/consulta/serie-plano?serie-plano=${serie}&page-size=10&page=0`;

      const { data } = await apiConvenio.get(lQuery);
      console.log(data);

    } catch (error) {
      console.log(error);
      errorMessage("Não foi possível realizar a consulta");
    } finally {
      setLoading(false);
    }
  };

  const getConvenioPorSerie = async () => {
    try {
      setLoading(true);

      let serie = 547;

      let lQuery = `/ultimo/${serie}/serie`;

      const { data } = await apiConvenio.get(lQuery);
      console.log(data);

    } catch (error) {
      console.log(error);
      errorMessage("Não foi possível realizar a consulta");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Spin spinning={loading} tip={tipLoading}>


      <Form layout='vertical' style={{ padding: 24 }}
        // onFinish={sendForm} 
        scrollToFirstError form={form} >


        <div className="main-content pl-sm-3 mt-4">
          <h1>Cadastrar Pessoa Jurídica</h1>
        </div>

        <Row>
          {
            <>
              <Button shape='round' type='primary' icon={<CheckOutlined />} htmlType='button'
                onClick={() => {
                  efpcAutorizacaoRequerer();
                }} >
                EFPC Autorização Requerer
              </Button>

              <Button shape='round' type='primary' icon={<CheckOutlined />} htmlType='button'
                onClick={() => {
                  efpcAutorizacaoRequererCadastroAutomaticoPjEfpc();
                }} >
                EFPC Autorização Requerer Com dadastro automático de PJ da EFPC
              </Button>

              <Button shape='round' type='primary' icon={<CheckOutlined />} htmlType='button'
                onClick={() => {
                  efpcAutorizacaoAprovar();
                }} >
                EFPC Autorização Aprovar
              </Button>

              {/* <Button shape='round' type='primary' icon={<CheckOutlined />} htmlType='button'
                onClick={() => {
                  efpcVersionar();
                }} >
                EFPC Versionar
              </Button> */}

            </>
          }
        </Row>

        <Row>
          {
            <>
              <Button shape='round' type='primary' icon={<CheckOutlined />} htmlType='button'
                onClick={() => {
                  efpcAlteracaoAprovar();
                }} >
                EFPC Alteracao Aprovar
              </Button>

              {/* <Button shape='round' type='primary' icon={<CheckOutlined />} htmlType='button'
                onClick={() => {
                  efpcVersionar();
                }} >
                EFPC Versionar
              </Button> */}

            </>
          }
        </Row>

        <Row>
          {
            <>
              <Button shape='round' type='primary' icon={<CheckOutlined />} htmlType='button'
                onClick={() => {
                  getOperacaoPorSeriePessoaJuridica();
                }} >
                Get Operação Por Série PJ
              </Button>

            </>
          }
        </Row>

        <Row>
          {
            <>
              <Button shape='round' type='primary' icon={<CheckOutlined />} htmlType='button'
                onClick={() => {
                  testeRedirectUri();
                }} >
                Teste URI
              </Button>

              <Button shape='round' type='primary' icon={<CheckOutlined />} htmlType='button'
                onClick={() => {
                  testeGetEfpcByNumero();
                }} >
                Get EFPC
              </Button>
            </>
          }
        </Row>

        <Row>
          {
            <>
              <Button shape='round' type='primary' icon={<CheckOutlined />} htmlType='button'
                onClick={() => {
                  testeGetEstados();
                }} >
                TEste GET Estados
              </Button>

            </>
          }
        </Row>

        <Row>
          {
            <>
              <Button shape='round' type='primary' icon={<CheckOutlined />} htmlType='button'
                onClick={() => {
                  pessoaJuridicaVersionarNumeroProcesso();
                }} >
                Cadastro de PJ Por Número de Processo
              </Button>

              <Button shape='round' type='primary' icon={<CheckOutlined />} htmlType='button'
                onClick={() => {
                  pessoaJuridicaVersionarNIT();
                }} >
                Cadastro de PJ Por NIT
              </Button>

            </>
          }
        </Row>

        <Row>
          {
            <Button shape='round' type='primary' icon={<CheckOutlined />} htmlType='button'
              onClick={() => {
                getPessoaJuridicaUltimo();
              }} >
              Pessoa Juridica último
            </Button>


          }
        </Row>

        <Row>
          {
            <Button shape='round' type='primary' icon={<CheckOutlined />} htmlType='button'
              onClick={() => {
                efpcVersionarSerie();
              }} >
              EFPC versionar por série
            </Button>


          }
        </Row>

        <Row>
          {
            <Button shape='round' type='primary' icon={<CheckOutlined />} htmlType='button'
              onClick={() => {
                planoAutorizacaoAprovarCadastroAutomaticoPjPlano();
              }} >
              Autorizar e Cadastrar Plano de Benefício
            </Button>
          }
        </Row>

        <Row>
          {
            <><Button shape='round' type='primary' icon={<CheckOutlined />} htmlType='button'
              onClick={() => {
                getConveniosPorSeriePlano();
              }}>
              Consultar Convênios por Série de Plano
            </Button>

              <Button shape='round' type='primary' icon={<CheckOutlined />} htmlType='button'
                onClick={() => {
                  getConvenioPorSerie();
                }}>
                Buscar Convênio por Serie
              </Button></>
          }
        </Row>

        <Row>
          {
            <Button shape='round' type='primary' icon={<CheckOutlined />} htmlType='button'
              onClick={() => {
                pushToBase(navigate);
              }} >
              Push to base
            </Button>
          }
        </Row>

      </Form>

    </Spin>
  );
};

export default TesteApi;

